import type { Meta, StoryObj } from '@storybook/react';

import { TOTAL_MISSIONS } from 'constants/mission';

import { Progressive } from './Progressive';

const meta: Meta<typeof Progressive> = {
  title: 'parts/loading/Progressive',
  component: Progressive,
  args: { progress: TOTAL_MISSIONS },
  tags: ['autodocs'],
};

export default meta;

type Story = StoryObj<typeof Progressive>;

export const Basic: Story = {
  render: args => <Progressive {...args} />,
};
